<lcs-loading-overlay class="flex-dir-col" [show]="callState | lcsCallState : 'loading'">
   <div [formGroup]="form$ | async" class="fax-email-address-form">
      <div class="compact-register-header flex-container space-between fax-padding">
         <div class="ml-auto">
            @if (isOnAdd || this.extensionPrivileges.canAddFaxEmails) {
            <button class="create-btn" type="button" mat-raised-button color="primary" (click)="onAddFaxEmail()">
               {{ isOnAdd ? 'Add Whitelisted Email' : 'Add Email' }}</button
            >
            }
         </div>
      </div>
      @if (isOnAdd ? hasVisibleFaxEmails : true) {
      <lcs-responsive-table [columns]="columns">
         <table
            #table
            lcs-table
            [dataSource]="faxEmailsArray.controls"
            formArrayName="faxEmailsArray"
            class="fax-padding"
         >
            <tr lcs-header-row *lcsResponsiveHeaderRowDef></tr>
            <tr
               lcs-row
               *lcsResponsiveRowDef="let index = dataIndex"
               [hidden]="faxEmailsArray.controls[index].value.isDeleted"
            ></tr>
            <ng-container lcsColumnDef="emailAddress" [width]="2">
               <th lcs-header-cell *lcsHeaderCellDef>Emails</th>
               <td lcs-cell *lcsCellDef="let index = dataIndex" [formGroupName]="index">
                  <mat-form-field
                     class="email-row"
                     [ngClass]="{
                        disabled:
                           !this.extensionPrivileges.canEditFaxEmails &&
                           faxEmailsArray?.controls[index]?.get('faxEmailAddressId')?.value != null
                     }"
                  >
                     <input matInput [type]="text" formControlName="emailAddress" [name]="'emailAddress' + index" />
                     @if (faxEmailsArray.controls[index]?.hasError('validateMultipleInput', 'emailAddress')) {
                     <mat-error> Only one email address is allowed. </mat-error>
                     } @if (faxEmailsArray.controls[index]?.hasError('validateInput', 'emailAddress')) {
                     <mat-error> Invalid email address or domain. </mat-error>
                     } @if (faxEmailsArray.controls[index]?.hasError('required', 'emailAddress')) {
                     <mat-error> Email is required. </mat-error>
                     }
                  </mat-form-field>
               </td>
            </ng-container>
            <ng-container lcsColumnDef="isDomainOnly" [width]="5">
               <th lcs-header-cell *lcsHeaderCellDef></th>
               <td lcs-cell *lcsCellDef="let index = dataIndex" [formGroupName]="index">
                  <div class="toggle-and-delete-container">
                     @if (isDomainOnly(index)) {
                     <mat-label>
                        <mat-icon class="warnign-icon">warning</mat-icon>
                        This will whitelist all email addresses with this domain
                     </mat-label>
                     }
                     <button
                        mat-icon-button
                        class="delete button"
                        type="button"
                        (click)="onDeleteClick(index)"
                        [ngClass]="{
                           disabled:
                              !this.extensionPrivileges.canDeleteFaxEmails &&
                              faxEmailsArray?.controls[index]?.get('faxEmailAddressId')?.value != null
                        }"
                     >
                        <mat-icon>delete</mat-icon>
                     </button>
                  </div>
               </td>
            </ng-container>
         </table>
      </lcs-responsive-table>
      }
   </div>
</lcs-loading-overlay>
